module.exports = __webpack_public_path__ + "static/media/kitgrande.d52a8fef.jpg";